import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';

// Páginas
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Colaboradores from './pages/Colaboradores/Colaboradores';
import CadastroColaborador from './pages/Colaboradores/CadastroColaborador';
import EditarColaborador from './pages/Colaboradores/EditarColaborador';
import Reunioes from './pages/Reunioes/Reunioes';
import CadastroReuniao from './pages/Reunioes/CadastroReuniao';
import EditarReuniao from './pages/Reunioes/EditarReuniao';
import DetalhesReuniao from './pages/Reunioes/DetalhesReuniao';
import Presencas from './pages/Presencas/Presencas';
import RegistroPresenca from './pages/Presencas/RegistroPresenca';
import RelatorioPresencas from './pages/Presencas/RelatorioPresencas';
import GerenciarPresencas from './pages/Presencas/GerenciarPresencas';
import Usuarios from './pages/Usuarios/Usuarios';
import CadastroUsuario from './pages/Usuarios/CadastroUsuario';
import Perfil from './pages/Perfil/Perfil';
import Cargos from './pages/Cargos/Cargos';
import CadastroCargo from './pages/Cargos/CadastroCargo';
import EditarCargo from './pages/Cargos/EditarCargo';
import DetalhesCargo from './pages/Cargos/DetalhesCargo';
import Congregacoes from './pages/Congregacoes/Congregacoes';
import CadastroCongregacao from './pages/Congregacoes/CadastroCongregacao';
import EditarCongregacao from './pages/Congregacoes/EditarCongregacao';
import Irmandade from './pages/Irmandade/Irmandade';
import CadastroIrmandade from './pages/Irmandade/CadastroIrmandade';
import EditarIrmandade from './pages/Irmandade/EditarIrmandade';

import { Visitas, VisitaForm, VisitaDetalhes, HistoricoMembro } from './pages/Visitas';
import Configuracoes from './pages/Configuracoes/Configuracoes';
import MapaCriancas from './pages/Mapa/MapaCriancas';
import RotaJovens from './pages/Mapa/RotaJovens';
import AnaliseFrequenciaTerritorial from './pages/Mapa/AnaliseFrequenciaTerritorial';
import Recitativos from './pages/Recitativos/Recitativos';
import NovoRecitativo from './pages/Recitativos/NovoRecitativo';
import FaltasRecitativos from './pages/Recitativos/FaltasRecitativos';
import DetalhesRecitativo from './pages/Recitativos/DetalhesRecitativo';
import PerfisUsuario from './pages/Perfis/PerfisUsuario';
import ReuniaoJovensList from './pages/ReuniaoJovens/ReuniaoJovensList';
import ReuniaoJovensNova from './pages/ReuniaoJovens/ReuniaoJovensNova';
import ReuniaoJovensDetalhes from './pages/ReuniaoJovens/ReuniaoJovensDetalhes';
import ReuniaoJovensAgenda from './pages/ReuniaoJovens/ReuniaoJovensAgenda';
import ReuniaoJovensDashboard from './pages/ReuniaoJovens/ReuniaoJovensDashboard';
import VisitasAniversario from './pages/VisitasAniversario/VisitasAniversario';
import VisitasAgendadas from './pages/VisitasAniversario/VisitasAgendadas';
import ReuniaoCriancasList from './pages/ReuniaoCriancas/ReuniaoCriancasList';
import ReuniaoCriancasDetalhes from './pages/ReuniaoCriancas/ReuniaoCriancasDetalhes';
import ReuniaoCriancasAgenda from './pages/ReuniaoCriancas/ReuniaoCriancasAgenda';
import ReuniaoCriancasDashboard from './pages/ReuniaoCriancas/ReuniaoCriancasDashboard';

// Componentes
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Routes>
          {/* Rota pública */}
          <Route path="/login" element={<Login />} />
          
          {/* Rotas protegidas */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* Rotas de Colaboradores */}
            <Route path="colaboradores" element={<Colaboradores />} />
            <Route path="colaboradores/novo" element={<CadastroColaborador />} />
            <Route path="colaboradores/cadastro" element={<CadastroColaborador />} />
            <Route path="colaboradores/editar/:id" element={<EditarColaborador />} />
            
            {/* Rotas de Reuniões */}
            <Route path="reunioes" element={<Reunioes />} />
            <Route path="reunioes/nova" element={<CadastroReuniao />} />
            <Route path="reunioes/cadastro" element={<CadastroReuniao />} />
            <Route path="reunioes/editar/:id" element={<EditarReuniao />} />
            <Route path="reunioes/detalhes/:id" element={<DetalhesReuniao />} />
            <Route path="reunioes/:id" element={<DetalhesReuniao />} />
            
            {/* Rotas de Presenças */}
            <Route path="presencas" element={<Presencas />} />
            <Route path="presencas/registro/:reuniaoId" element={<RegistroPresenca />} />
            <Route path="presencas/relatorio" element={<RelatorioPresencas />} />
            <Route path="presencas/gerenciar/:id" element={<GerenciarPresencas />} />
            
            {/* Rotas de Usuários */}
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="usuarios/novo" element={<CadastroUsuario />} />
            <Route path="usuarios/cadastro" element={<CadastroUsuario />} />
            <Route path="usuarios/editar/:id" element={<CadastroUsuario />} />

            {/* Perfis de Usuário */}
            <Route path="perfis-usuario" element={<PerfisUsuario />} />
            
            {/* Meu Perfil */}
            <Route path="perfil" element={<Perfil />} />
            
            {/* Rotas de Cargos */}
            <Route path="cargos" element={<Cargos />} />
            <Route path="cargos/novo" element={<CadastroCargo />} />
            <Route path="cargos/cadastro" element={<CadastroCargo />} />
            <Route path="cargos/editar/:id" element={<EditarCargo />} />
            <Route path="cargos/:id" element={<DetalhesCargo />} />
            
            {/* Rotas de Congregações */}
            <Route path="congregacoes" element={<Congregacoes />} />
            <Route path="congregacoes/nova" element={<CadastroCongregacao />} />
            <Route path="congregacoes/cadastro" element={<CadastroCongregacao />} />
            <Route path="congregacoes/editar/:id" element={<EditarCongregacao />} />
            
            {/* Rotas de Irmandade */}
            <Route path="irmandade/*" element={<Irmandade />} />
            <Route path="irmandade/cadastro" element={<CadastroIrmandade />} />
            <Route path="irmandade/editar/:id" element={<EditarIrmandade />} />

            
            {/* Rotas de Visitas */}
            <Route path="visitas" element={<Visitas />} />
            <Route path="visitas/mocidade" element={<Visitas tipo="mocidade" />} />
            <Route path="visitas/criancas" element={<Visitas tipo="criancas" />} />
            <Route path="visitas/ajuntamento" element={<Visitas tipo="ajuntamento" />} />
            <Route path="visitas/reuniao-familiar" element={<Visitas tipo="reuniao_familiar" />} />
            <Route path="visitas/reuniao-evangelizacao" element={<Visitas tipo="reuniao_evangelizacao" />} />
            <Route path="visitas/nova" element={<VisitaForm />} />
            <Route path="visitas/nova/:tipo" element={<VisitaForm />} />
            <Route path="visitas/editar/:id" element={<VisitaForm />} />
            <Route path="visitas/detalhes/:id" element={<VisitaDetalhes />} />
            <Route path="visitas/membro/:membroId/historico" element={<HistoricoMembro />} />
            
            {/* Rotas de Recitativos */}
            <Route path="recitativos" element={<Recitativos />} />
            <Route path="recitativos/novo" element={<NovoRecitativo />} />
            <Route path="recitativos/faltas" element={<FaltasRecitativos />} />
            <Route path="recitativos/:id" element={<DetalhesRecitativo />} />

            {/* Rotas de Reunião de Jovens */}
            <Route path="reuniao-jovens" element={<ReuniaoJovensList />} />
            <Route path="reuniao-jovens/dashboard" element={<ReuniaoJovensDashboard />} />
            <Route path="reuniao-jovens/agenda" element={<ReuniaoJovensAgenda />} />
            <Route path="reuniao-jovens/nova" element={<ReuniaoJovensNova />} />
            <Route path="reuniao-jovens/:id" element={<ReuniaoJovensDetalhes />} />

            {/* Rotas de Reunião de Crianças */}
            <Route path="reuniao-criancas" element={<ReuniaoCriancasList />} />
            <Route path="reuniao-criancas/dashboard" element={<ReuniaoCriancasDashboard />} />
            <Route path="reuniao-criancas/agenda" element={<ReuniaoCriancasAgenda />} />
            <Route path="reuniao-criancas/aniversariantes" element={<VisitasAniversario />} />
            <Route path="reuniao-criancas/visitas-agendadas" element={<VisitasAgendadas />} />
            <Route path="reuniao-criancas/:id" element={<ReuniaoCriancasDetalhes />} />

            {/* Rotas legadas de Visitas de Aniversário (redirect) */}
            <Route path="visitas-aniversario" element={<Navigate to="/reuniao-criancas/aniversariantes" replace />} />
            <Route path="visitas-aniversario/agendadas" element={<Navigate to="/reuniao-criancas/visitas-agendadas" replace />} />

            {/* Rota de Territorialização / Mapa */}
            <Route path="mapa" element={<MapaCriancas />} />
            <Route path="analise-territorial-frequencia" element={<AnaliseFrequenciaTerritorial />} />
            <Route path="rota-jovens" element={<RotaJovens />} />
            
            {/* Rota de Configurações */}
            <Route path="configuracoes" element={<Configuracoes />} />
          </Route>
          
          {/* Rota padrão - redirecionar para login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;